export default __webpack_public_path__ + "static/indoor15-adfa3bb60b37d27b5878c43cb9f5099b.webp";